import { Component, input, viewChild } from '@angular/core';
import { IColumn } from '@app/shared/interfaces/column.interface';
import { TableComponent } from '@shared/components/table-component/table.component';
import { IFiltredDashboardResponse } from '@app/shared/interfaces/dashboard.interface';
import { ExcelButtonComponent } from '@app/shared/components/excel-button/excel-button.component';
import { CommonModule } from '@angular/common';
import { CardComponent } from '@app/shared/components/card/card.component';

@Component({
    selector: 'app-agent-information',
    imports: [CommonModule, TableComponent, ExcelButtonComponent, CardComponent],
    templateUrl: './agent-information.component.html',
    styleUrl: './agent-information.component.scss'
})
export class AgentInformationComponent {
    priceColumnTemplate = viewChild('priceColumnTemplate');
    agentCellTemplate = viewChild('agentCellTemplate');
    airlineBadgeTemplate = viewChild('airlineBadgeTemplate');
    paxChipTemplate = viewChild('paxChipTemplate');

    loading = input<boolean>(false);
    agentInformationData = input<IFiltredDashboardResponse['agentInformation']['results']>();

    cols: IColumn[] = [];

    ngOnInit() {
        this.cols = [
            { key: 'agentName', label: 'Agent', template: this.agentCellTemplate(), sortable: true },
            { key: 'reservation', label: 'Reservation', sortable: true },
            { key: 'adult', label: 'Adult', sortable: true },
            { key: 'child', label: 'Child', sortable: true },
            { key: 'infant', label: 'Infant', sortable: true },
            { key: 'topSellerAirline', label: 'Top Airline', template: this.airlineBadgeTemplate(), sortable: true },
            { key: 'revenue', label: 'Price', template: this.priceColumnTemplate(), sortable: true, sortField: 'revenue.amount' },
            { key: 'totalPax', label: 'Total Pax', template: this.paxChipTemplate(), sortable: true }
        ];
    }

    exportData(): any[] {
        return (
            this.agentInformationData()?.map((item) => ({
                reservation: item.reservation ?? '',
                agentName: item.agentName ?? '',
                adult: item.adult ?? '',
                child: item.child ?? '',
                infant: item.infant ?? '',
                topSellerAirline: item.topSellerAirline ?? '',
                revenue: `${item.revenue?.currency ?? ''} ${item.revenue?.amount?.toFixed(2) ?? ''}`,
                totalPax: item.totalPax ?? '',
                lastYearPax: item.lastYearPax ?? ''
            })) ?? []
        );
    }

    getInitials(name: string): string {
        if (!name) return 'AG';
        return name.replace(/[^A-Z ]/g, '').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('') || 'AG';
    }
}
